const API = import.meta.env.VITE_URL_API;

export {
  API,
};